module.exports = "<!--The content below is only a placeholder and can be replaced.-->\n<app-design-presentation></app-design-presentation>\n"